<template>
  <div id="templatePDF" class="page" style="top: 0; left: 0; z-index: -99">
    <div class="pdf-area-container" style="display: flex; align-items: center">
      <div style="display: flex; align-items: center">
        <img
          style="max-height: 25px; max-width: 200px"
          src="/static/logo-ecotrace-a.png"
          alt="Logo Trace Beef"
        />
      </div>
      <h1>Relatório de Abate</h1>
      <div class="container-cod-ident">
        <span>Código de Identificação</span>
        <h2
          style="
            border: 1px solid black;
            border-radius: 10px;
            padding: 5px 15px;
            font-size: 18px;
          "
          v-if="romaneio.track_id"
        >
          {{ romaneio.track_id }}
        </h2>
      </div>
    </div>

    <div class="pdf-area-container">
      <div class="hide-vertical-text" style="margin-right: 10px">
        <span>Propriedade</span>
        <p>{{ romaneio.fazenda.nome | capitalize }}</p>
      </div>

      <div class="hide-vertical-text" style="margin-right: 10px">
        <span>Produtor</span>
        <p>{{ romaneio.produtor.nome_razaosocial | capitalize }}</p>
      </div>
      <div class="hide-vertical-text" style="margin-right: 10px">
        <span>Município / UF</span>
        <p>
          {{ romaneio.fazenda.cidade | capitalize }}/{{
            romaneio.fazenda.estado
          }}
        </p>
      </div>
      <div>
        <div>
          <span>CPF/CNPJ</span>
          <p>{{ romaneio.produtor.cpf_cnpj }}</p>
        </div>
        <div>
          <span>IE</span>
          <p>{{ romaneio.produtor.ie }}</p>
        </div>
      </div>
      <div style="min-width: 60px"></div>
    </div>

    <div class="pdf-area-container">
      <div>
        <span>Frigorífico Abate</span>
        <p>{{ romaneio.industry.name }}</p>
      </div>
      <div>
        <span>Município / UF</span>
        <p>
          {{ romaneio.industry.address_city }}/{{
            romaneio.industry.address_state
          }}
        </p>
      </div>
      <div>
        <span>Num SIF</span>
        <p>{{ romaneio.industria.sif_sie }}</p>
      </div>
    </div>

    <div>
      <p style="margin-bottom: 0; margin-top: 10px">Informações Técnicas</p>
      <div style="display: flex">
        <div
          class="pdf-area-container"
          style="flex-direction: column; margin-right: 4px"
        >
          <div>
            <span>Data do Abate</span>
            <p>{{ romaneio.dt_abate | formatDate }}</p>
          </div>
        </div>
        <div
          class="pdf-area-container"
          style="flex-direction: column; margin-right: 4px"
        >
          <span>Hora de Início</span>
          <p style="text-align: center">
            {{ romaneio.hr_inicio | formatHour }}
          </p>
        </div>
        <div
          class="pdf-area-container"
          style="flex-direction: column; margin-right: 4px"
        >
          <span>Hora de Término</span>
          <p style="text-align: center">
            {{ romaneio.hr_fim | formatHour }}
          </p>
        </div>
        <div class="pdf-area-container" style="flex-direction: column">
          <span>Tempo total</span>
          <p style="text-align: center">{{ romaneio.tempo_total }} h</p>
        </div>
      </div>
    </div>

    <div>
      <p style="margin-bottom: 0; margin-top: 10px">
        Informações gerais do lote
      </p>
      <div style="display: flex; justify-content: flex-start; height: 80px">
        <div
          class="pdf-area-container"
          style="flex-direction: column; width: 200px; margin-right: 4px"
          v-if="
            romaneio.industria.sif_sie !== (Number('0941') || Number('941'))
          "
        >
          <span>Raça</span>
          <h2>{{ racaPredominante }}</h2>
        </div>
        <div
          class="pdf-area-container"
          style="flex-direction: column; width: 200px; margin-right: 4px"
        >
          <span>Categoria</span>
          <h2>{{ categoria }}</h2>
        </div>
        <div
          class="pdf-area-container"
          style="flex-direction: column; width: 250px; margin-right: 4px"
        >
          <span>Sexo</span>
          <h2>{{ romaneio.sexo == 'M' ? 'Macho' : 'Fêmea' }}</h2>
        </div>
        <div
          class="pdf-area-container"
          style="flex-direction: column; margin-right: 4px; text-align: center"
        >
          <span>Total/Kg</span>
          <h2>{{ romaneio.total_peso_carcaca }}kg</h2>
        </div>
        <div
          class="pdf-area-container"
          style="flex-direction: column; text-align: center"
        >
          <span>Total/@</span>
          <h2>{{ romaneio.total_arroba }}@</h2>
        </div>
      </div>
    </div>

    <div>
      <div style="display: flex; justify-content: flex-start; height: 90px">
        <div
          class="pdf-area-container"
          style="flex-direction: column; margin-right: 4px; text-align: center"
        >
          <span>Qtde Animais</span>
          <h2>{{ romaneio.qtde_cab }}</h2>
        </div>
        <div
          class="pdf-area-container"
          style="
            flex-direction: column;
            margin-right: 4px;
            text-align: center;
            align-items: center;
          "
        >
          <span>Média/Peso Vivo</span>
          <h2>{{ romaneio.media_peso_vivo }}kg</h2>
        </div>
        <div
          class="pdf-area-container"
          style="flex-direction: column; margin-right: 4px; text-align: center"
        >
          <span>Média/Carcaça</span>
          <h2>{{ romaneio.media_peso_carcaca }}kg</h2>
        </div>
        <div
          class="pdf-area-container"
          style="flex-direction: column; margin-right: 4px; text-align: center"
        >
          <span>Média/@</span>
          <h2>{{ romaneio.media_arroba }}@</h2>
        </div>
        <div
          class="pdf-area-container"
          style="flex-direction: column; margin-right: 4px; text-align: center"
        >
          <span>Média/Rendimento</span>
          <h2>{{ romaneio.media_rc }}%</h2>
        </div>
      </div>
    </div>

    <div>
      <div
        style="display: flex; justify-content: space-between; margin-top: 3px"
      >
        <div class="pdf-column-container" style="margin-right: 4px">
          <h2 style="text-align: center; margin-bottom: 10px">Acabamento</h2>
          <table class="horizontal-table">
            <tr>
              <th style="width: 150px; text-align: left">Acabamento</th>
              <th
                style="width: 150px; border: 2px solid black; border-top: 0px"
              >
                Qtde Cab.
              </th>
              <th style="width: 100px">%</th>
            </tr>
            <template v-for="(item, index) in graphAcabemnto">
              <tr style="border-bottom: 2px solid black" v-bind:key="index">
                <td>{{ item.name }}</td>
                <td
                  style="
                    border-left: 2px solid black;
                    border-right: 2px solid black;
                    text-align: center;
                  "
                >
                  {{ item.total }}
                </td>
                <td style="text-align: center">
                  {{ item.percentage }}
                </td>
              </tr>
            </template>
            <tr>
              <td style="text-align: right; padding-right: 5px">Total</td>
              <td
                style="
                  border-left: 2px solid black;
                  border-right: 2px solid black;
                  text-align: center;
                "
              >
                <strong>{{ totalAcabamento }}</strong>
              </td>
              <td style="text-align: center">
                <strong>100</strong>
              </td>
            </tr>
          </table>

          <div style="max-width: 400px; text-align: center; margin-top: 10px">
            <aux-chart
              class="aux-chart canvasSize"
              :chartdata="graphAcabemnto"
            ></aux-chart>
          </div>
        </div>

        <div class="pdf-column-container" style="margin-right: 4px">
          <div>
            <h2 style="text-align: center; margin-bottom: 10px">Maturidade</h2>
            <table>
              <tr>
                <th style="width: 150px; text-align: left">Dentes</th>
                <th
                  style="width: 150px; border: 2px solid black; border-top: 0"
                >
                  Qtde Cab.
                </th>
                <th style="width: 100px">%</th>
              </tr>
              <template v-for="(item, index) in graphMaturidade">
                <tr style="border-bottom: 2px solid black" v-bind:key="index">
                  <td>{{ item.name }}</td>
                  <td
                    style="
                      border-left: 2px solid black;
                      border-right: 2px solid black;
                      text-align: center;
                    "
                  >
                    {{ item.total }}
                  </td>
                  <td style="text-align: center">
                    {{ item.percentage }}
                  </td>
                </tr>
              </template>
              <tr>
                <td style="text-align: right; padding-right: 5px">Total</td>
                <td
                  style="
                    border-left: 2px solid black;
                    border-right: 2px solid black;
                    text-align: center;
                  "
                >
                  <strong>{{ totalMaturidade }}</strong>
                </td>
                <td style="text-align: center">
                  <strong>100</strong>
                </td>
              </tr>
            </table>
          </div>

          <div style="max-width: 400px; text-align: center; margin-top: 10px">
            <aux-chart
              class="aux-chart canvasSize"
              :chartdata="graphMaturidade"
            ></aux-chart>
          </div>
        </div>

        <div class="pdf-column-container" style="margin-right: 4px">
          <div>
            <h2 style="text-align: center; margin-bottom: 10px">
              Faixa de Pesos
            </h2>
            <table>
              <tr>
                <th style="width: 150px; text-align: left">Peso</th>
                <th
                  style="width: 150px; border: 2px solid black; border-top: 0"
                >
                  Qtde Cab.
                </th>
                <th style="width: 100px">%</th>
              </tr>
              <template v-for="(item, index) in graphFaixaPesos">
                <tr style="border-bottom: 2px solid black" v-bind:key="index">
                  <td>{{ item.name }}</td>
                  <td
                    style="
                      border-left: 2px solid black;
                      border-right: 2px solid black;
                      text-align: center;
                    "
                  >
                    {{ item.total }}
                  </td>
                  <td style="text-align: center">
                    {{ item.percentage }}
                  </td>
                </tr>
              </template>

              <tr>
                <td style="text-align: right; padding-right: 5px">Total</td>
                <td
                  style="
                    border-left: 2px solid black;
                    border-right: 2px solid black;
                    text-align: center;
                  "
                >
                  <strong>{{ totalPeso }}</strong>
                </td>
                <td style="text-align: center">
                  <strong>100</strong>
                </td>
              </tr>
            </table>
          </div>

          <div style="max-width: 400px; text-align: center; margin-top: 10px">
            <aux-chart
              class="aux-chart canvasSize"
              :chartdata="graphFaixaPesos"
            ></aux-chart>
          </div>
        </div>
      </div>
    </div>

    <div style="display: flex; justify-content: space-between; margin-top: 7px">
      <div
        class="pdf-column-container"
        style="margin-right: 4px; height: 320px"
      >
        <div>
          <h2 style="text-align: center; margin-bottom: 10px">
            Peso de Carcaça
          </h2>
          <aux-chart
            class="aux-chart canvasSize"
            :chartdata="pesosIntervalosCarcaca"
            :total="'value'"
          ></aux-chart>
        </div>
      </div>

      <div
        class="pdf-column-container"
        style="
          justify-content: space-between;
          max-width: 355px;
          margin-right: 4px;
          height: 320px;
        "
      >
        <div>
          <h2 style="text-align: center; margin-bottom: 10px">Conformação</h2>

          <table style="max-width: 385px; margin: auto">
            <tr>
              <th style="width: 150px; text-align: left">Conformação</th>
              <th style="width: 150px; border: 2px solid black; border-top: 0">
                Qtde Cab.
              </th>
              <th style="width: 100px">%</th>
            </tr>
            <template v-for="(item, index) in graphConformacao">
              <tr style="border-bottom: 2px solid black" v-bind:key="index">
                <td>{{ item.name }}</td>
                <td
                  style="
                    border-left: 2px solid black;
                    border-right: 2px solid black;
                    text-align: center;
                  "
                >
                  {{ item.total }}
                </td>
                <td style="text-align: center">
                  {{ item.percentage }}
                </td>
              </tr>
            </template>
            <tr>
              <td style="text-align: right; padding-right: 5px">Total</td>
              <td
                style="
                  border-left: 2px solid black;
                  border-right: 2px solid black;
                  text-align: center;
                "
              >
                <strong>{{ totalConformacao }}</strong>
              </td>
              <td style="text-align: center">
                <strong>100</strong>
              </td>
            </tr>
          </table>
        </div>
      </div>

      <div
        class="pdf-area-container"
        style="
          padding: 15px;
          align-items: center;
          max-width: 355px;
          flex-direction: column;
          margin-right: 4px;
          height: 320px;
        "
      >
        <table id="table-condenacoes">
          <tr>
            <td colspan="3">
              <h2 style="text-align: center; margin-bottom: 5px">
                Condenações
              </h2>
            </td>
          </tr>
          <tr>
            <th
              style="
                width: 150px;
                text-align: left;
                background-color: rgba(0, 0, 0, 0.4);
                border-bottom: 2px solid white;
                text-align: center;
              "
            >
              Total de Animais
            </th>
            <th
              style="
                width: 150px;
                border: 2px solid white;
                border-top: 0;
                background-color: rgba(0, 0, 0, 0.4);
              "
            >
              Qtde Cab DIF.
            </th>
            <th
              style="
                width: 100px;
                background-color: rgba(0, 0, 0, 0.4);
                border-bottom: 2px solid white;
              "
            >
              %
            </th>
          </tr>
          <tr style="border-bottom: 2px solid white">
            <td
              style="background-color: rgba(0, 0, 0, 0.1); text-align: center"
            >
              {{ romaneio.qtde_cab }}
            </td>
            <td
              style="
                border-left: 2px solid white;
                border-right: 2px solid white;
                text-align: center;
                background-color: rgba(0, 0, 0, 0.1);
              "
            >
              {{ totalDIF }}
            </td>
            <td
              style="text-align: center; background-color: rgba(0, 0, 0, 0.1)"
            >
              {{ porcentCondenacoes }}
            </td>
          </tr>
          <tr>
            <td colspan="3" style="height: 25px">
              <span style="font-size: 13px; font-style: italic"
                >*DIF –Departamento de Inspeção Final</span
              >
            </td>
          </tr>
        </table>

        <table id="table-condenacoes">
          <tr>
            <td colspan="3">
              <h2 style="text-align: center; margin-bottom: 5px">Contusões</h2>
            </td>
          </tr>
          <tr>
            <th
              style="
                width: 150px;
                text-align: left;
                background-color: rgba(0, 0, 0, 0.4);
                border-bottom: 2px solid white;
                text-align: center;
              "
            >
              Total de Animais
            </th>
            <th
              style="
                width: 150px;
                border: 2px solid white;
                border-top: 0;
                background-color: rgba(0, 0, 0, 0.4);
              "
            >
              Qtde cab. Contusões
            </th>
            <th
              style="
                width: 100px;
                background-color: rgba(0, 0, 0, 0.4);
                border-bottom: 2px solid white;
              "
            >
              %
            </th>
          </tr>
          <tr style="border-bottom: 2px solid white">
            <td
              style="background-color: rgba(0, 0, 0, 0.1); text-align: center"
            >
              {{ romaneio.qtde_cab }}
            </td>
            <td
              style="
                border-left: 2px solid white;
                border-right: 2px solid white;
                text-align: center;
                background-color: rgba(0, 0, 0, 0.1);
              "
            >
              {{ romaneio.total_contusoes }}
            </td>
            <td
              style="text-align: center; background-color: rgba(0, 0, 0, 0.1)"
            >
              {{ porcentContusoes }}
            </td>
          </tr>
        </table>
      </div>
    </div>

    <div
      style="
        margin-bottom: 10px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
      "
    >
      <div>
        <p style="margin-bottom: 0; margin-top: 10px">
          Informações Financeiras
        </p>
        <div style="display: flex; justify-content: flex-start; height: 90px">
          <div
            class="pdf-area-container"
            style="flex-direction: column; min-width: 200px; margin-right: 4px"
          >
            <span>Valor @Realizado/R$</span>
            <h2
              v-if="romaneio.negotiation && romaneio.negotiation.value"
              style="text-align: right"
            >
              {{ currencyFormatter.format(romaneio.negotiation.value) }}
            </h2>
            <h2 v-else style="text-align: right">R$0.00</h2>
          </div>
          <div
            class="pdf-area-container"
            style="flex-direction: column; min-width: 200px; margin-right: 4px"
          >
            <span>Valor Total/R$</span>
            <h2
              v-if="romaneio.negotiation && romaneio.negotiation.value"
              style="text-align: right"
            >
              {{
                currencyFormatter.format(
                  parseInt(
                    romaneio.negotiation.value * romaneio.total_arroba
                  ).toFixed(2)
                )
              }}
            </h2>
            <h2 v-else style="text-align: right">R$0.00</h2>
          </div>
        </div>
      </div>
      <div
        style="display: flex; flex-direction: column; justify-content: flex-end"
      >
        <div style="margin-right: 10px">
          <span style="margin-right: 10px"
            >https://web.ecotrace.solutions/</span
          >
          <span style="margin-right: 10px">-</span>
          <span id="pdf-timestamp">{{ timestamp }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import appApi from '../../plugins/api'
import moment from 'moment'
import Chart from 'chart.js'
import jsPDF from 'jspdf'
import html2canvas from 'html2canvas'
import AuxChart from './AuxChart'
import DispersaoChart from '../../components/romaneio/DispersaoChart'

export default {
  components: {
    'aux-chart': AuxChart,
    'dispersao-chart': DispersaoChart
  },
  name: 'relatorio-pdf',
  props: [
    'load',
    'auxs',
    'romaneio',
    'animal',
    'categoria',
    'graphAcabemnto',
    'graphMaturidade',
    'graphFaixaPesos',
    'graphDistRaca',
    'graphConformacao',
    'pesosIntervalosCarcaca',
    'racaPredominante',
    'totalAcabamento',
    'totalMaturidade',
    'totalPeso',
    'totalConformacao',
    'totalDIF',
    'trackId'
  ],

  data() {
    return {
      idRelatorio: null,
      porcentCondenacoes: null,
      porcentContusoes: null,
      timestamp: null,
      currencyFormatter: null
    }
  },
  created: function () {},

  mounted: function () {
    this.currencyFormatter = new Intl.NumberFormat([], {
      style: 'currency',
      currency: 'BRL'
    })
  },
  methods: {
    startDownload(trackId) {
      this.calcPorcentCondenacoes(this.totalDIF, this.romaneio.qtde_cab)
      this.calcPorcentContusoes(
        this.romaneio.total_contusoes,
        this.romaneio.qtde_cab
      )
      this.timestamp = moment().format('DD/MM/YYYY HH:mm:ss')
      this.downloadPDF(trackId)
    },

    downloadPDF(id) {
      //templatePDF
      // setTimeout(() => {
      //   var wraper = document.getElementById("page-wrapper");
      //   //wraper.style.overflow = "hidden";
      //   var containerRef = document.getElementById("templatePDF")
      //   window.scrollTo(0,0)
      //   html2canvas(containerRef, { allowTaint: true, useCORS: true,scrollX: 0, scrollY: 0, logging: false }).then((canvas) => {
      //     var imgData = canvas.toDataURL('image/png')
      //     var doc = new jsPDF("p", "mm", "a4");
      //     var width = doc.internal.pageSize.getWidth();
      //     var height = doc.internal.pageSize.getHeight();
      //     doc.addImage(imgData, 'PNG', 5, 5, (width - 10), (height - 10));
      //     doc.save(`romaneio_${id}.pdf`);
      //     this.$emit('finish-download');
      //   });
      // }, 1000);
    },

    calcPorcentCondenacoes(valor, valorTotal) {
      let valorPorcent = 0

      valorPorcent = ((100 / parseInt(valorTotal)) * valor).toFixed(2)

      this.porcentCondenacoes = valorPorcent
    },

    calcPorcentContusoes(valor, valorTotal) {
      let valorPorcent = 0

      valorPorcent = ((100 / parseInt(valorTotal)) * valor).toFixed(2)

      this.porcentContusoes = valorPorcent
    }
  }
}
</script>
<style scoped lang="css">
.hide-vertical-text {
  overflow: hidden;
  width: 300px;
  max-height: 83px;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2; /* number of lines to show */
}

#templatePDF {
  background-color: white;
  padding: 5px;
  width: 1100px;
}

.pdf-area-container {
  display: flex;
  padding: 5px 20px;
  border: 1px solid black;
  border-radius: 10px;
  margin: 2.5px 0;
  justify-content: space-between;
}

p {
  font-weight: bold;
  font-size: 18px;
  margin: 0;
}

th {
  font-size: 18px;
}

table,
th,
td {
  border-collapse: collapse;
}

th {
  border-bottom: 2px solid black;
}

.infos-divididas {
  display: flex;
  justify-content: space-between;
}

.pdf-column-container {
  display: flex;
  max-width: 355px;
  flex-direction: column;
  padding: 15px;
  border: 1px solid black;
  border-radius: 10px;
}

#table-condenacoes th,
#table-condenacoes td {
  height: 35px;
}

#table-condenacoes {
  margin: auto;
}

.canvasSize {
  position: relative;
  max-height: 200px;
}

/* .page {
  width: 210mm;
  min-height: 297mm;
  padding: 20mm;
  margin: 10mm auto;
  border: 1px #d3d3d3 solid;
  border-radius: 5px;
  background: white;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
} */
</style>
